import { defineStore } from "pinia";
import { ref } from "vue";

// Whether the platform-review card is on screen. All the gating and timing logic lives in
// usePlatformReview.composable.ts — this store is just the on/off switch App.vue reads to render
// <PlatformReviewCard> and the composable/card write to open or close it.
export const usePlatformReviewStore = defineStore("platformReview", () => {
  // state
  const isOpen = ref(false);

  // actions
  const open = () => {
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  return {
    // state
    isOpen,

    // actions
    open,
    close,
  };
});
